import { Condition } from '../../generated.graphql';

export const formatCondition = (condition: Condition) => {
  switch (condition) {
    case Condition.New: return 'New';
    case Condition.Preloved: return 'Preloved';
    default: return condition
  }
}
